import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermsValue } from '../../../packages/JsonQuery';

export const selectPromoSearchTypes = createSelector(selectJsonQuery, jsonQuery =>
  getTermsValue('promo_search_types')(jsonQuery),
);
